/** @format */

import { CommonModule, NgOptimizedImage } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  HomefieldIconLibraryModule,
  HomefieldIconsLibraryService,
  homefieldIconAlertErrorFill,
  homefieldIconLocationNearmeFill,
  homefieldIconLocationPinFill,
  homefieldIconMobilePhoneFill,
  homefieldIconArrowRightOutline,
  homefieldIconSearchOutline,
  homefieldIconSignCircledCheckFill,
} from '@dsg-tech/homefield-angular-icons';

import { AccordionComponent } from '../accordion/accordion.component';
import { AlertMessageModule } from '../alert-message/alert-message.module';
import {
  HmfButtonComponent,
  HmfRadioComponent,
  HmfRadioGroupComponent,
} from '@dsg-tech/homefield-angular';
import { NgModule } from '@angular/core';
import { ProgressSpinnerComponent } from '../progress-spinner/progress-spinner.component';
import { SideNavComponent } from '../side-nav/side-nav.component';
import { StoreLayerComponent } from './store-layer.component';
import { UrlSanitizerPipe } from '@shared/utils/pipes';

@NgModule({
  declarations: [StoreLayerComponent],
  imports: [
    AccordionComponent,
    AlertMessageModule,
    CommonModule,
    FormsModule,
    HmfButtonComponent,
    HmfRadioComponent,
    HmfRadioGroupComponent,
    HomefieldIconLibraryModule,
    NgOptimizedImage,
    ProgressSpinnerComponent,
    ReactiveFormsModule,
    SideNavComponent,
    UrlSanitizerPipe,
  ],
  exports: [StoreLayerComponent],
})
export class StoreLayerModule {
  constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
    homefieldIconsLibraryService.registerIcons([
      homefieldIconSearchOutline,
      homefieldIconArrowRightOutline,
      homefieldIconLocationNearmeFill,
      homefieldIconLocationPinFill,
      homefieldIconMobilePhoneFill,
      homefieldIconSignCircledCheckFill,
      homefieldIconAlertErrorFill,
    ]);
  }
}
